import { gql } from '@apollo/client';

const uploadPDF = gql`
  mutation ($pdf: Upload!, $agent_id: String, $name: String!) {
    uploadPDF(agent_id: $agent_id, name: $name, pdf: $pdf)
  }
`;
export default uploadPDF;
